// api.js
import axios from 'axios'
import store from '@/store'   
import router from '@/router'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Accept-Version': import.meta.env.VITE_API_VERSION,
  },
})

// Add a response interceptor to handle 401 globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the server responded with a 401 Unauthorized
    if (error.response && error.response.status === 401) {
      console.warn('Session expired or unauthorized. Redirecting to login...');
      
      store.dispatch('user/logout'); 
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

export default api
